import React, { FC, useCallback } from 'react';

import { Table } from '@column/column-ui-kit';

import { useBankAccountDropdown, useDebounce } from '~/hooks';

interface BankAccountCellProps {
  isEditable?: boolean;
  value?: string;
  onChange?: ({ description, id }: { description: string; id: string }) => void;
}

export const BankAccountCell: FC<BankAccountCellProps> = ({ value, onChange: onChangeProp, isEditable }) => {
  const { options, hiddenOptions, searchBankAccounts, isLoading } = useBankAccountDropdown(value);

  const onChange = useCallback(
    (newValue: { description: string; id: string }) => {
      onChangeProp?.({
        description: newValue.description,
        id: newValue.id,
      });
    },
    [onChangeProp, options]
  );

  const handleSearchBankAccounts = useDebounce(
    async (searchValue?: string) => {
      searchBankAccounts({ description: searchValue ?? '' });
    },
    500,
    [searchBankAccounts]
  );

  return (
    <Table.OptionCell
      value={value}
      options={options}
      hiddenOptions={hiddenOptions}
      fullWidth
      isEditable={isEditable}
      search
      searchLabel="Search for description"
      onSearchChange={handleSearchBankAccounts}
      isLoading={isLoading}
      onChange={(newValue: string) =>
        onChange?.({
          description: options.find((option) => option.value === newValue)?.label ?? '',
          id: newValue,
        })
      }
    />
  );
};
